import {TaskCategory} from '@modifi/enums'
import {generatePath} from '@modifi/router'
import {TaskRelatedEntityView} from '@modifi/onboarding-api-clients'

import {
  ROUTE_COMPANY_FINANCIAL_DOCUMENTS,
  ROUTE_COMPANY_GROUP_FINANCIAL_DOCUMENTS,
  ROUTE_COMPANY_TRADE_PARTNERS_BY_ID,
} from '../../../../../routes/constants'

export const getTaskLink = (
  taskCategory: TaskCategory,
  relatedEntities?: TaskRelatedEntityView[]
): string => {
  let link = ''
  if (taskCategory === TaskCategory.COMPANY_FINANCIAL_REVIEW) {
    link = ROUTE_COMPANY_FINANCIAL_DOCUMENTS
  } else if (taskCategory === TaskCategory.COMPANY_GROUP_FINANCIAL_REVIEW) {
    link = ROUTE_COMPANY_GROUP_FINANCIAL_DOCUMENTS
  } else if (taskCategory === TaskCategory.TRADE_PARTNER_INSURANCE_LIMIT_HIGH_AMOUNT_APPLICATION) {
    link = generatePath(ROUTE_COMPANY_TRADE_PARTNERS_BY_ID, {
      externalId: relatedEntities?.find(entity => entity.name === 'TradePartnerCompany')!.key!,
    })
  }

  return `${link}?source=tasks`
}
